import { Kosik } from "./Kosik.js";
import { KonfiguraceZbrane as KF } from "./KonfiguraceZbrane.js";
//import ls from "local-storage";
import { PanelZbrane } from "./PanelZbrane.js";
require("@fancyapps/fancybox");

//require('webpack-jquery-ui/highlight-effect');
//import 'jquery-ui/ui/widgets/dialog';

var WidgetKosik = {
  container: false, //--container
  Panel: false,

  _init: function() {
    //Lc.h("fdsa");
    // if(KF.vybraneVolby())this.nactiUlozenePolozky();
    // this.nactiUrlAdresy();
  },

  createDiv: function($id) {
    this.container = $('<div id="' + $id + '"></div>');

    return this.container;
  },

  zobraz: function() {
    //if(window.location.pathname.startsWith(KF.url))return false;
    Lc.h("Zobrazení widgetu");
    this.Panel = new Panel(this.container);

    $(document).on("ladzo:aktualizaceWidgetuKosiku", function() {
      Lc.log("akutalizuj widget");
      WidgetKosik.Panel.aktualizuj();
      if (KF.odkazyJakoIframe) WidgetKosik.Panel.odkazyDoPopupOkna();
    });
  }
};

class Panel {
  constructor($div) {
    this.div = $div;

    this.vypisZahlavi();
    this.vypisBody();
    this.naplDatyKosiku();

    this.nastavUdalosti();

    if (KF.odkazyJakoIframe) this.odkazyDoPopupOkna();
  }

  aktualizuj() {
    // this.div.effect('highlight');
    //$('#dvWgK').effect('highlight');
    this.naplDatyKosiku();
  }

  vratProduktyProTyp($typ) {
    var $arr = [];
    _.forEach(Kosik.polozky, function($Val) {
      //function($Val, $priceId)
      //Lc.log($priceId);
      if ($typ == $Val.druhZbozi) {
        $arr.push($Val);
      }
    });
    return $arr;
  }

  naplDatyKosiku() {
    Lc.f("WidgetKosik:naplDatyKosiku");
    if (!KF.vybraneVolby()) {
      this.div.find(".dvBody").html("");
      return false;
    }

    var $kod = "",
      $div = "";

    _.forEach(KF.vybrano, function($Val, $key) {
      let $title = PanelZbrane["Panely"][$key].title; //Zbraň
      $div += el("div", $title + ": " + el("strong", KF[$key][$Val].name)); //Šavle
    });

    $kod += el("div.a", $div);

    var $tento = this;
    var $pr = "";
    _.forEach(KF.urlAdresy, function($url, $key) {
      let $pom = "";

      let $nzv = el("h3", KF[$key].title);
      let $produkty = $tento.vratProduktyProTyp($key);

      if ($produkty.length) {
        $pom += el("span.ikona.ok");
      } else {
        $pom +=
          el("span.ikona.ne") + el('a.vyber[href="' + $url + '"]', "vyber");
      }

      $pr += el("div", [$nzv, el("div", $pom)]);
    });

    $kod += el("div.flx", $pr);

    this.div.find(".dvBody").html($kod);
  }

  vypisZahlavi() {
    let $kod = el(
      "div.dvZahl>h2",
      el('a[href="' + KF.url + '"]', "Sestav si zbraň")
    );
    this.div.append($kod);
  }
  vypisBody() {
    let $kod = el("div.dvBody.non", "Nějaký obsah");
    this.div.append($kod);
  }

  nastavUdalosti() {
    //--obrazeni tela
    var $div = this.div;
    $div.on("mouseenter", function() {
      $(this)
        .find(".dvBody")
        .slideDown("slow");
    });
    $div.on("mouseleave", function() {
      $(this)
        .find(".dvBody")
        .hide();
    });
  }

  odkazyDoPopupOkna() {
    var $div = this.div;
    $div.find(".dvBody .flx a").each(function() {
      //var $href = $(this).attr("href");
      //$(this).attr("href", $href + "#iframe");
      $(this).attr("data-fancybox", "");
      $(this).attr("data-type", "iframe");

      $(this).fancybox({
        autoStart: false,
        iframe: {
          preload: true,
          css: {
            height: window.innerHeight - 50 + "px"
          }
        },

        afterClose: function() {
          Lc.e("Magnfic close");
          Kosik.aktualizujZavisle();
        }
      });
      /*
      $(this).magnificPopup({
        //preloader: true,
        type: "iframe",
        iframe: {
          markup:
            '<div class="mfp-iframe-scaler your-special-css-class">' +
            '<div class="mfp-close"></div>' +
            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen>            </iframe>' +
            "</div>"
        },
        //preloader: true,

        callbacks: {
          beforeOpen: function() {
            Lc.f("iframe:beforeOpen");
            var $href = $(this).attr("href");
            $(this).attr("href", $href + "#iframe");
          },

          close: function() {
            Lc.e("Magnfic close");
            Kosik.aktualizujZavisle();
            //$(document).trigger("ladzo:aktualizaceWidgetuKosiku");
            // Will fire when popup is closed
          }
          // e.t.c.
        }
      });
      */
    });
  }
} //class Pane

WidgetKosik._init();

export { WidgetKosik };
